export class CustomerModel{
    public ID:string;
    constructor(){
        
    }
}
export class CustomerShort{
    public ID:string;
    public JobsiteId:string;
    public DisplayName:string;
    public Phone:string;
    public Address:string;
    public PhoneNumbers:string;
    public JobSiteCount:number;
}